module.exports = __webpack_public_path__ + "img/Emotiva-logo-dash.776d150f.png";